
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/sdks/php",
      function () {
        return require("private-next-pages/events/sdks/php.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/sdks/php"])
      });
    }
  